import { useEffect, useId } from "react";

import { getDocument, getWindow } from "@thelabnyc/thelabui/src/utils/dom";

import { getPageSetting, usePageSetting } from "../utils/settings";

/**
 * React Component to add the Google reCaptcha script to the page.
 */
export const CaptchaLibrary = (props: { onLoad?: () => void }): null => {
    const scriptID = useId();
    const sitekey = usePageSetting("google_recaptcha_sitekey");

    useEffect(() => {
        if (!sitekey) {
            return;
        }
        const document = getDocument();
        if (!document) return;

        const script = document.createElement("script");
        script.id = scriptID;
        script.type = "text/javascript";
        script.async = true;
        script.src = `https://www.google.com/recaptcha/api.js?render=${sitekey}`;
        if (props.onLoad) {
            script.onload = props.onLoad;
        }
        // Inject script into DOM
        const scriptSibling = document.getElementsByTagName("script")[0];
        scriptSibling.parentNode?.insertBefore(script, scriptSibling);
    }, [sitekey]);

    return null;
};

/**
 * Call this on form submit to get the captcha token value
 */
export const getCaptchaToken = async (
    action: string,
): Promise<string | null> => {
    const window = getWindow();
    const sitekey = getPageSetting("google_recaptcha_sitekey");
    if (!window?.grecaptcha || !sitekey) {
        return null;
    }
    return window.grecaptcha.execute(sitekey, { action: action });
};
